import { formatDecimalForInput } from "../../../../../../../common/input/parseDecimalInput";

export const formatPercentageAdjustment = (fraction: number): string =>
  `${formatDecimalForInput(Number((fraction * 100).toFixed(6)))} %`;
